import { Maatregel } from "@/entities/vsm";
import { useMaatregelContext } from "@/features/vsm/maatregel-context";
import { ActionsDropdown, DropdownMenuItem } from "@/shared/components";
import { cn } from "@/shared/utils";
import { CopyNaarNieuwButton } from "./maatregel-tags";

export function MaatregelActions({ maatregel }: Readonly<{ maatregel: Maatregel }>) {
    const { deleteMaatregel, isEditEnabled, startEdit } = useMaatregelContext();
    // a RijdtGroep itself is never handmatig toegevoegd, but the treinseries it groups can be copied over in one go
    const maatregelenToBeCopied = maatregel.type === "RijdtGroep" ? maatregel.maatregelen.filter((m) => m.handmatigToegevoegd) : [];
    const hasCopyableGroep = maatregelenToBeCopied.length > 0;

    return (
        <div className={cn("ml-2 flex items-center", !hasCopyableGroep && "group-data-[variant=oud]:hidden")}>
            {hasCopyableGroep && <CopyNaarNieuwButton maatregelen={maatregelenToBeCopied} title="Alle treinseries kopiëren" />}
            <ActionsDropdown
                className="hidden group-data-[variant=nieuw]:inline-flex group-data-[variant=oud]:hidden"
                icon="menu-overflow-vertical"
                data-testid="edit-maatregel"
                disabled={!isEditEnabled}
            >
                <DropdownMenuItem itemID={maatregel.id} onSelect={() => startEdit(maatregel)}>
                    Treinserie bewerken
                </DropdownMenuItem>
                {maatregel.type !== "RijdtGroep" && (
                    <DropdownMenuItem itemID={maatregel.id} onSelect={() => deleteMaatregel(maatregel.id)}>
                        Treinserie verwijderen
                    </DropdownMenuItem>
                )}
            </ActionsDropdown>
        </div>
    );
}
